module.exports = __webpack_public_path__ + "static/Pete Stevenson@2x-f15caf5d9800cb2448e60584e2991723.png";